import React from 'react';
import './banya.scss';
import {Col, Container, Row} from 'react-bootstrap';

import BanyaPhotos from '../../data/banya.json';

function Banya() {
    return (
        <div id="banya" className="pt70">
            <div className="banya pt50">
                <div className="parallaxHat"></div>
                <div className="parallaxVenik"></div>
                <Container>
                    <Row>
                        <Col md={12} className="mb50">
                            <div className="section-title">Our banya</div>
                            <h2>Our Banya/Sauna</h2>
                        </Col>
                        <Col md={12} className="mb50">
                            <div className="subtitle">Our Banya offers a traditional spa experience with steam rooms,
                                herbal treatments, and relaxation zones.
                                Experience the banya in the serene Cyprus mountains, where wellness, relaxation, and
                                nature come together for everyone.
                            </div>
                            <div className="blocklist">
                                {BanyaPhotos && BanyaPhotos.map((item) => {
                                    return (
                                        <div className="item" key={item.id}>
                                            <img src={item.image} alt={item.alt} />
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="subtitle center">
                                <a className="" href="https://banya-cy.com/" target="_blank" rel="noreferrer">More details and photos</a>
                            </div>
                            <div className="center">
                                <a className="book-now-btn mb40 btn-orange" href="https://banya-cy.setmore.com"
                                   target="_blank" rel="noreferrer">Book your relax time</a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Banya;
